import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { Cell } from '../TimeGrid.types';

dayjs.extend(isBetween);

export function getCellsMapped(yFirstAxis: number[], minutes: string[]) {
  return yFirstAxis.reduce(
    (
      hours: Map<number, { minutes: Map<number, Cell>; index: number }>,
      hourLabel: number,
      currentIndex: number
    ) => {
      const hourAndMinute = minutes.reduce((minuteMap: Map<number, Cell>, minuteLabel: string) => {
        return minuteMap.set(Number(minuteLabel), {});
      }, new Map<number, Cell>());

      hours.set(hourLabel, {
        minutes: hourAndMinute,
        index: currentIndex,
      });

      return hours;
    },
    new Map<number, { minutes: Map<number, Cell>; index: number }>()
  );
}

export const getHourMinute = (time: number, timezone = 'GMT') => {
  return dayjs(time * 1000)
    .tz(timezone)
    .format('hh:mm a');
};

export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${remainingSeconds}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${remainingSeconds}s`;
  } else {
    return `${remainingSeconds}s`;
  }
};

export const createCloneDiv = (target: HTMLDivElement, id: string) => {
  const clonedNode = target.cloneNode(false) as HTMLDivElement;
  clonedNode.style.position = 'absolute';
  clonedNode.style.top = `${target.offsetTop}px`;
  clonedNode.style.left = `${target.offsetLeft}px`;
  clonedNode.style.height = `fit-content`;
  clonedNode.style.width = `fit-content`;
  clonedNode.style.zIndex = '10';
  clonedNode.style.boxShadow = '0 0 0 3px black';
  clonedNode.style.borderRadius = '4px';
  clonedNode.style.borderStyle = 'none';
  clonedNode.id = id;

  return clonedNode;
};
